//actions
export const ADD_NOTE = 'ADD_NOTE';
export const REMOVE_NOTE = 'REMOVE_NOTE';
export const LOG_ME = 'LOG_ME';
export const NEW_PROJECT = 'NEW_PROJECT';
export const CLEAR_CURRENT_PROJECT = 'CLEAR_CURRENT_PROJECT';
export const NEW_USER = 'NEW_USER';
export const NEW_ACTIVITY = 'NEW_ACTIVITY';
export const CLEAR_CURRENT_ACTIVITY = 'CLEAR_CURRENT_ACTIVITY';
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const SET_SHOW_TEAM_IN_TIMESHEET = 'SET_SHOW_TEAM_IN_TIMESHEET';
export const SELECT_USER_FOR_TIMESHEET = 'SELECT_USER_FOR_TIMESHEET';

//async
export const REQUEST_GET_ALL_PROJECTS_FOR_ADMIN =
  'REQUEST_GET_ALL_PROJECTS_FOR_ADMIN';
export const SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN =
  'SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN';
export const FAIL_GET_ALL_PROJECTS_FOR_ADMIN =
  'FAIL_GET_ALL_PROJECTS_FOR_ADMIN';

export const REQUEST_GET_ALL_USERS_FOR_ADMIN =
  'REQUEST_GET_ALL_USERS_FOR_ADMIN';
export const SUCCESS_GET_ALL_USERS_FOR_ADMIN =
  'SUCCESS_GET_ALL_USERS_FOR_ADMIN';
export const FAIL_GET_ALL_USERS_FOR_ADMIN = 'FAIL_GET_ALL_USERS_FOR_ADMIN';

export const REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN =
  'REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN';
export const SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN =
  'SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN';
export const FAIL_GET_ALL_USERS_IN_STAGE_FOR_ADMIN =
  'FAIL_GET_ALL_USERS_IN_STAGE_FOR_ADMIN';
export const REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN =
  'REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN';
export const SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN =
  'SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN';
export const FAIL_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN =
  'FAIL_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN';

export const REQUEST_GET_PROJECT_DATA = 'REQUEST_GET_PROJECT_DATA';
export const SUCCESS_GET_PROJECT_DATA = 'SUCCESS_GET_PROJECT_DATA';
export const FAIL_GET_PROJECT_DATA = 'FAIL_GET_PROJECT_DATA';

export const REQUEST_DELETE_USER_FROM_STAGE = 'REQUEST_DELETE_USER_FROM_STAGE';
export const SUCCESS_DELETE_USER_FROM_STAGE = 'SUCCESS_DELETE_USER_FROM_STAGE';
export const FAIL_DELETE_USER_FROM_STAGE = 'FAIL_DELETE_USER_FROM_STAGE';

export const REQUEST_DELETE_SELF_USER_FROM_STAGE =
  'REQUEST_DELETE_SELF_USER_FROM_STAGE';
export const SUCCESS_DELETE_SELF_USER_FROM_STAGE =
  'SUCCESS_DELETE_SELF_USER_FROM_STAGE';
export const FAIL_DELETE_SELF_USER_FROM_STAGE =
  'FAIL_DELETE_SELF_USER_FROM_STAGE';

export const REQUEST_ADD_USER_TO_STAGE = 'REQUEST_ADD_USER_TO_STAGE';
export const SUCCESS_ADD_USER_TO_STAGE = 'SUCCESS_ADD_USER_TO_STAGE';
export const FAIL_ADD_USER_TO_STAGE = 'FAIL_ADD_USER_TO_STAGE';

export const REQUEST_ADD_SELF_USER_TO_STAGE = 'REQUEST_ADD_SELF_USER_TO_STAGE';
export const SUCCESS_ADD_SELF_USER_TO_STAGE = 'SUCCESS_ADD_SELF_USER_TO_STAGE';
export const FAIL_ADD_SELF_USER_TO_STAGE = 'FAIL_ADD_SELF_USER_TO_STAGE';

export const REQUEST_GET_USER_DATA_FOR_ADMIN =
  'REQUEST_GET_USER_DATA_FOR_ADMIN';
export const SUCCESS_GET_USER_DATA_FOR_ADMIN =
  'SUCCESS_GET_USER_DATA_FOR_ADMIN';
export const FAIL_GET_USER_DATA_FOR_ADMIN = 'FAIL_GET_USER_DATA_FOR_ADMIN';

export const REQUEST_GET_AUTH_USER_DATA = 'REQUEST_GET_AUTH_USER_DATA';
export const SUCCESS_GET_AUTH_USER_DATA = 'SUCCESS_GET_AUTH_USER_DATA';
export const FAIL_GET_AUTH_USER_DATA = 'FAIL_GET_AUTH_USER_DATA';

export const REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA =
  'REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA';
export const SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA =
  'SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA';
export const FAIL_GET_USER_ACTIVE_PROJECT_TREE_DATA =
  'FAIL_GET_USER_ACTIVE_PROJECT_TREE_DATA';

export const REQUEST_GET_USER_INACTIVE_PROJECT_TREE_DATA =
  'REQUEST_GET_USER_INACTIVE_PROJECT_TREE_DATA';
export const SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA =
  'SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA';
export const FAIL_GET_USER_INACTIVE_PROJECT_TREE_DATA =
  'FAIL_GET_USER_INACTIVE_PROJECT_TREE_DATA';

export const REQUEST_GET_TIME_SHEET_DATA = 'REQUEST_GET_TIME_SHEET_DATA';
export const SUCCESS_GET_TIME_SHEET_DATA = 'SUCCESS_GET_TIME_SHEET_DATA';
export const FAIL_GET_TIME_SHEET_DATA = 'FAIL_GET_TIME_SHEET_DATA';

export const REQUEST_GET_TIME_SHEET_DATA_OF_USER =
  'REQUEST_GET_TIME_SHEET_DATA_OF_USER';
export const SUCCESS_GET_TIME_SHEET_DATA_OF_USER =
  'SUCCESS_GET_TIME_SHEET_DATA_OF_USER';
export const FAIL_GET_TIME_SHEET_DATA_OF_USER =
  'FAIL_GET_TIME_SHEET_DATA_OF_USER';

export const REQUEST_GET_ALL_INCOME_EXPENSE = 'REQUEST_GET_ALL_INCOME_EXPENSE';
export const SUCCESS_GET_ALL_INCOME_EXPENSE = 'SUCCESS_GET_ALL_INCOME_EXPENSE';
export const FAIL_GET_ALL_INCOME_EXPENSE = 'FAIL_GET_ALL_INCOME_EXPENSE';

export const REQUEST_DELETE_INCOME_EXPENSE_ENTRY =
  'REQUEST_DELETE_INCOME_EXPENSE_ENTRY';
export const SUCCESS_DELETE_INCOME_EXPENSE_ENTRY =
  'SUCCESS_DELETE_INCOME_EXPENSE_ENTRY';
export const FAIL_DELETE_INCOME_EXPENSE_ENTRY =
  'FAIL_DELETE_INCOME_EXPENSE_ENTRY';

export const REQUEST_ADD_INCOME_EXPENSE_ENTRY =
  'REQUEST_ADD_INCOME_EXPENSE_ENTRY';
export const SUCCESS_ADD_INCOME_EXPENSE_ENTRY =
  'SUCCESS_ADD_INCOME_EXPENSE_ENTRY';
export const FAIL_ADD_INCOME_EXPENSE_ENTRY = 'FAIL_ADD_INCOME_EXPENSE_ENTRY';

export const REQUEST_GET_INCOME_EXPENSE_BALANCE =
  'REQUEST_GET_INCOME_EXPENSE_BALANCE';
export const SUCCESS_GET_INCOME_EXPENSE_BALANCE =
  'SUCCESS_GET_INCOME_EXPENSE_BALANCE';
export const FAIL_GET_INCOME_EXPENSE_BALANCE =
  'FAIL_GET_INCOME_EXPENSE_BALANCE';

export const REQUEST_GET_CALENDAR_DATA = 'REQUEST_GET_CALENDAR_DATA';
export const SUCCESS_GET_CALENDAR_DATA = 'SUCCESS_GET_CALENDAR_DATA';
export const FAIL_GET_CALENDAR_DATA = 'FAIL_GET_CALENDAR_DATA';

export const REQUEST_GET_ALL_ACTIVITIES = 'REQUEST_GET_ALL_ACTIVITIES';
export const SUCCESS_GET_ALL_ACTIVITIES = 'SUCCESS_GET_ALL_ACTIVITIES';
export const FAIL_GET_ALL_ACTIVITIES = 'FAIL_GET_ALL_ACTIVITIES';

export const REQUEST_GET_ACTIVITY_DATA = 'REQUEST_GET_ACTIVITY_DATA';
export const SUCCESS_GET_ACTIVITY_DATA = 'SUCCESS_GET_ACTIVITY_DATA';
export const FAIL_GET_ACTIVITY_DATA = 'FAIL_GET_ACTIVITY_DATA';

export const REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN =
  'REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN';
export const SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN =
  'SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN';
export const FAIL_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN =
  'FAIL_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN';
export const REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN =
  'REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN';
export const SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN =
  'SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN';
export const FAIL_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN =
  'FAIL_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN';

export const REQUEST_DELETE_USER_FROM_ACTIVITY =
  'REQUEST_DELETE_USER_FROM_ACTIVITY';
export const SUCCESS_DELETE_USER_FROM_ACTIVITY =
  'SUCCESS_DELETE_USER_FROM_ACTIVITY';
export const FAIL_DELETE_USER_FROM_ACTIVITY = 'FAIL_DELETE_USER_FROM_ACTIVITY';

export const REQUEST_ADD_USER_TO_ACTIVITY = 'REQUEST_ADD_USER_TO_ACTIVITY';
export const SUCCESS_ADD_USER_TO_ACTIVITY = 'SUCCESS_ADD_USER_TO_ACTIVITY';
export const FAIL_ADD_USER_TO_ACTIVITY = 'FAIL_ADD_USER_TO_ACTIVITY';

export const REQUEST_GET_USER_ACTIVITIES_DATA =
  'REQUEST_GET_USER_ACTIVITIES_DATA';
export const SUCCESS_GET_USER_ACTIVITIES_DATA =
  'SUCCESS_GET_USER_ACTIVITIES_DATA';
export const FAIL_GET_USER_ACTIVITIES_DATA = 'FAIL_GET_USER_ACTIVITIES_DATA';

export const REQUEST_GET_HOLIDAY_INFO = 'REQUEST_GET_HOLIDAY_INFO';
export const SUCCESS_GET_HOLIDAY_INFO = 'SUCCESS_GET_HOLIDAY_INFO';
export const FAIL_GET_HOLIDAY_INFO = 'FAIL_GET_HOLIDAY_INFO';

export const REQUEST_GET_USER_DATA_FOR_SELF = 'REQUEST_GET_USER_DATA_FOR_SELF';
export const SUCCESS_GET_USER_DATA_FOR_SELF = 'SUCCESS_GET_USER_DATA_FOR_SELF';
export const FAIL_GET_USER_DATA_FOR_SELF = 'FAIL_GET_USER_DATA_FOR_SELF';

export const REQUEST_GET_SELF_STATS = 'REQUEST_GET_SELF_STATS';
export const SUCCESS_GET_SELF_STATS = 'SUCCESS_GET_SELF_STATS';
export const FAIL_GET_SELF_STATS = 'FAIL_GET_SELF_STATS';

export const REQUEST_GET_SELF_CLAIMS = 'REQUEST_GET_SELF_CLAIMS';
export const SUCCESS_GET_SELF_CLAIMS = 'SUCCESS_GET_SELF_CLAIMS';
export const FAIL_GET_SELF_CLAIMS = 'FAIL_GET_SELF_CLAIMS';

export const REQUEST_GET_USER_CLAIMS = 'REQUEST_GET_USER_CLAIMS';
export const SUCCESS_GET_USER_CLAIMS = 'SUCCESS_GET_USER_CLAIMS';
export const FAIL_GET_USER_CLAIMS = 'FAIL_GET_USER_CLAIMS';

export const REQUEST_GET_All_USERS_STATS = 'REQUEST_GET_All_USERS_STATS';
export const SUCCESS_GET_All_USERS_STATS = 'SUCCESS_GET_All_USERS_STATS';
export const FAIL_GET_All_USERS_STATS = 'FAIL_GET_All_USERS_STATS';

export const LOADING_GET_STAGE_STATS = 'LOADING_GET_STAGE_STATS';
export const REQUEST_GET_STAGE_STATS = 'REQUEST_GET_STAGE_STATS';
export const SUCCESS_GET_STAGE_STATS = 'SUCCESS_GET_STAGE_STATS';
export const FAIL_GET_STAGE_STATS = 'FAIL_GET_STAGE_STATS';

export const LOADING_GET_PROJECT_STATS = 'LOADING_GET_PROJECT_STATS';
export const REQUEST_GET_PROJECT_STATS = 'REQUEST_GET_PROJECT_STATS';
export const SUCCESS_GET_PROJECT_STATS = 'SUCCESS_GET_PROJECT_STATS';
export const FAIL_GET_PROJECT_STATS = 'FAIL_GET_PROJECT_STATS';

export const LOADING_GET_ACTIVITY_STATS = 'LOADING_GET_ACTIVITY_STATS';
export const REQUEST_GET_ACTIVITY_STATS = 'REQUEST_GET_ACTIVITY_STATS';
export const SUCCESS_GET_ACTIVITY_STATS = 'SUCCESS_GET_ACTIVITY_STATS';
export const FAIL_GET_ACTIVITY_STATS = 'FAIL_GET_ACTIVITY_STATS';
